import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/PeanutButterRockstar/ProductShowcase";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Footer from "../../components/Footer";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import { Helmet } from "react-helmet";
const PeanutButterRockstar = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Helmet>
        <title>Peanut Butter Rockstar - Nutty & Sweet with a Heavy Body High | BeyondBloom™</title>
        <meta
          name="description"
          content="Peanut Butter Rockstar is a flavorful strain with nutty and sweet notes, delivering a powerful body high. Perfect for deep relaxation and stress relief."
        />
        <meta
          name="keywords"
          content="Peanut Butter Rockstar strain, cannabis, body high, nutty cannabis, sweet cannabis, relaxation, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Peanut Butter Rockstar - Nutty & Sweet with a Heavy Body High | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Peanut Butter Rockstar is a flavorful strain with nutty and sweet notes, delivering a powerful body high. Perfect for deep relaxation and stress relief."
        />
        <meta property="og:image" content="/images/peanut-butter-rockstar.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/peanut-butter-rockstar" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Peanut Butter Rockstar - Nutty & Sweet with a Heavy Body High | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Peanut Butter Rockstar is a flavorful strain with nutty and sweet notes, delivering a powerful body high. Perfect for deep relaxation and stress relief."
        />
        <meta name="twitter:image" content="/images/peanut-butter-rockstar.png" />
      </Helmet>
      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default PeanutButterRockstar;
